import { FC, useEffect, useState } from 'react'
import useUser from '../../../hooks/User'
import { useChatStore } from '../../../stores/ChatStore'
import { ToC } from '../../../components/Chat/ToC'
import { PageNoPermisson } from '../general/PageNoPermission'
import { useSettingsStore } from '../../../stores/SettingsStore'
import useAccessToken from '../../../hooks/AccessToken'
import { ChatSidebar } from '../../../components/Chat/ChatSidebar'
import { ChatWindow } from '../../../components/Chat/ChatWindow'
import moment from 'moment';
import { io } from 'socket.io-client';
import Swal from 'sweetalert2'
import axios from 'axios'
import useSWR, { mutate } from 'swr'
import { clearDB } from '../../../db'
import { ChatAside } from '../../../components/Chat/ChatAside'
import { ChatSetting } from '../../../components/Chat/Settings/ChatSetting'
import { ChatLabelSetting } from '../../../components/Chat/Settings/ChatLabelSetting'
import { ChatDetailLabelSetting } from '../../../components/Chat/Settings/ChatDetailLabelSetting'
import { ChatQuickReplySetting } from '../../../components/Chat/Settings/ChatQuickReplySetting'
import { SettingMultiMeetings, SettingMultiPipelines } from '../../../interfaces/Settings'
import { usePipelineStore } from '../../../stores/PipelineStore'
import { useUserStore } from '../../../stores/UserStore'
import ModalForwardChat from '../../../components/Chat/Modal/ForwardChat/ModalForwardChat'
import { getInitGroupSyncData, getInitSyncData } from '../../../api/ChatCRUD'
import { chatMode, countUnreadMessages, delay, hasSentMessages, isMerchantOnly, sortChatRooms, stringToColor } from '../../../functions/chat'
import SelectUser from '../../../components/Chat/Onboarding/SelectUser'
import { useMeetingStore } from '../../../stores/MeetingsStore'
import useDynamicTab from '../../../hooks/useDynamicTab'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { ChatInititate } from '../../../components/Chat/ChatInitiate'
import { ContactChatProps } from '../../../interfaces/Chat/ContactChat'
import { getSettingAll } from '../../../api/SettingCRUD'
import { ChatAgent, ChatGroupMessage, ChatGroupParticipant, ChatMessage } from '../../../interfaces/Chat/Chat'
import { ChatAnalytics } from '../../../components/Chat/Analytics/ChatAnlytics'
import { DailyChatSummary } from '../../../components/Chat/Analytics/DailyChatSummary'
import { useMerchantStore } from '../../../stores/MerchantStore'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { useProductStore } from '../../../stores/ProductStore'
import useHandleCheckSessionChat from '../../../hooks/HandleCheckSessionChat'

const Chat: FC = () => {
    const API_URL = process.env.REACT_APP_API_URL
    const token = useAccessToken()
    const {
        setMode, agreedTNC, setSelectedChatPhone, selectedChatPhone, setListChatGroupRooms, setListChatGroupMessages, forwardChatPayload,
        socket, setLastSynced, setMessageNotifications, setGroupMessageNotifications, setListChatRooms, setListChatMessages, setIsSyncing,
        connected, lastSynced, setListChatAgents, tokenChat, setSocket, setIsGroupSyncing, setIsWaitingForNetwork, forwardChatGroupPayload,
        windowActive, menuActive, setChatLabels, setChatContacts, phoneNumber, setQuickReplies, groupID, setSelectedChatGroupsForward,
        isOpenForwardChat, setIsOpenForwardChat, setForwardChatGroupPayload, setForwardChatPayload, setSelectedChatsForward
    } = useChatStore()
    const { handleCheckSession } = useHandleCheckSessionChat();
    const { settings, setSettings } = useSettingsStore()
    const { setSimplePipelines, setSelectMultiPipeline, setMultiPipelines } = usePipelineStore()
    const { setSimpleMeetings, setSelectMultiMeeting, setMultiMeetings } = useMeetingStore()
    const { setSimpleProducts } = useProductStore()
    const { setUsers } = useUserStore()
    const { setMultiMerchants } = useMerchantStore()
    const user = useUser()
    const location = useLocation(); // Dapatkan current path
    const [isTabActive, setIsTabActive] = useState(true)
    const intl = useIntl()
    let totalChatMessage = 0
    let totalChatGroupMessage = 0

    const getAgentUrl = () => {
        if (tokenChat && settings.chat_version === 'v2') {
            const queryParams = selectedChatPhone.map((phone) => `phonesId[]=${encodeURIComponent(phone.id)}`).join('&');
            if (user.data.is_superadmin) return `${API_URL}chat-agent/admin/sessions?${queryParams}`
            else return `${API_URL}chat-agent/agent/sessions?${queryParams}`
        } else return null
    }

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const { data: version = [], isLoading: versionLoading } = useSWR(`${API_URL}version`, fetcher)
    const { data: labels = [], isLoading: labelsIsLoading } = useSWR(`${API_URL}/chat/labels`, fetcher)
    const { data: quickRepliesData = [], isLoading: quickRepliesIsLoading } = useSWR(`${API_URL}/chat/quick-replies`, fetcher)
    const { data: leadTemplate = [], isLoading: leadTemplateLoading } = useSWR(`${API_URL}lead-templates`, fetcher)
    const { data: meetingTemplate = [], isLoading: meetingTemplateLoading } = useSWR(`${API_URL}meeting-templates`, fetcher)
    const { data: userData = [], isLoading: usersLoading } = useSWR(`${API_URL}simple-users`, fetcher)
    const { data: leads = [], isLoading: leadsLoading } = useSWR(`${API_URL}simple-leads`, fetcher)
    const { data: simpleMeetingsData = [], isLoading: simpleMeetingsLoading } = useSWR(`${API_URL}simple-meetings`, fetcher)
    const { data: simpleProductsData = [], isLoading: simpleProductsLoading } = useSWR(`${API_URL}simple-products`, fetcher)
    const { data: contacts = [], error: contactsError, isLoading: contactsLoading } = useSWR(tokenChat ? `${API_URL}chat/contacts/${selectedChatPhone[0].phone}` : null, fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false })
    const { data: agents, isLoading: isLoadingAgents } = useSWR(getAgentUrl(), fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false })
    const { data: resultMultiMerchant = [], isLoading: resultMultiMerchantisLoading } = useSWR(`${API_URL}merchant-templates`, fetcher)

    useEffect(() => {
        if (!resultMultiMerchantisLoading && Array.isArray(resultMultiMerchant) && resultMultiMerchant.length > 0) {
            setMultiMerchants(resultMultiMerchant);
        }
    }, [resultMultiMerchant, resultMultiMerchantisLoading]);

    function getLatestDate(dateA?: string | null, dateB?: string | null): string | null {
        const a = dateA ?? null;
        const b = dateB ?? null;

        if (!a && !b) return null;
        if (!a) return b;
        if (!b) return a;

        return moment(a).isAfter(moment(b)) ? a : b;
    }

    const getInitSync = async (currentLimit: number, isNew: boolean, dataRoom: ChatMessage | null, until: string, since: string, phone: string, color: string, isFirst: boolean, valTokenChat: string) => {
        setIsSyncing(() => true)

        try {
            const response = await getInitSyncData(currentLimit, dataRoom?.phone!, until, since, phone, valTokenChat, chatMode(settings.chat_version), token);
            if (response.data.success) {
                const { listChatRooms, listChatMessages, phoneNumber, isSyncRoom, setIsSyncRoom, setMessages } = useChatStore.getState();
                let tempChatRooms = { ...listChatRooms };
                let tempChatMessages = { ...listChatMessages };
                let dataInit = response.data.data;

                dataInit.rooms.forEach((chat: any) => {
                    if (isMerchantOnly(settings, chat, user) || (!settings.chat_show_pic_only && !user.data.is_superadmin) || (!settings.chat_superadmin_merchant_only && user.data.is_superadmin)) {
                        let key = `${chat.roomPhone}-${chat.as}`;

                        let tempChat = {
                            ...chat.chats[0] || null,
                            phone: chat.roomPhone,
                            as: chat.as,
                            action: {
                                isEditing: false
                            }
                        }

                        if (!tempChatRooms[key]) {
                            tempChatRooms[key] = {
                                as: chat.as,
                                roomPhone: chat.roomPhone,
                                roomName: chat.roomName ? chat.roomName : chat.roomPhone,
                                isMerchantOnly: chat.isMerchantOnly,
                                chat: tempChat,
                                labels: [],
                                merchants: [],
                                pipelines: [],
                                color: color,
                                connected: true,
                                selected: false,
                                loading: false,
                            }
                        } else {
                            if (isFirst) {
                                tempChatRooms[key] = {
                                    ...tempChatRooms[key],
                                    roomName: chat.roomName
                                }
                            } else if (!isFirst && !dataRoom) {
                                tempChatRooms[key] = {
                                    ...tempChatRooms[key],
                                    as: chat.as,
                                    roomPhone: chat.roomPhone,
                                    roomName: chat.roomName ? chat.roomName : chat.roomPhone,
                                    chat: tempChat,
                                }
                            } else if (!tempChatRooms[key].chat.id) {
                                tempChatRooms[key] = {
                                    ...tempChatRooms[key],
                                    chat: tempChat,
                                }
                            }
                        }
                        
                        if (isNew && phoneNumber !== key) {
                            setMessageNotifications((prevNotifications) => {
                                const prev = prevNotifications[key];
                                const latestId = chat.chats[0].id;

                                return {
                                    ...prevNotifications,
                                    [key]: {
                                        ...prev,
                                        idLatestMessage: latestId,
                                        latestMessage: chat.chats[0].message,
                                        unreadCount: dataRoom ? null :
                                            prev?.idLatestMessage === latestId ? prev?.unreadCount || 0 : hasSentMessages(chat.chats) ?
                                                countUnreadMessages(chat.chats) : (prevNotifications[key]?.unreadCount || 0) + countUnreadMessages(chat.chats),
                                    },
                                };
                            });
                        }
                        
                        const sortChatMessage = chat.chats.map((temp: ChatMessage) => ({
                            ...temp,
                            phone: chat.roomPhone,
                            as: chat.as,
                            action: {
                                isEditing: false
                            }
                        })).sort((a: ChatMessage, b: ChatMessage) => new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime());

                        if (!tempChatMessages[key]) {
                            tempChatMessages[key] = [...sortChatMessage]
                        } else {
                            if (isFirst) {
                                tempChatMessages[key] = [...sortChatMessage, ...tempChatMessages[key]]
                            } else {
                                if (dataRoom) tempChatMessages[key] = [...sortChatMessage, ...tempChatMessages[key]]
                                else tempChatMessages[key] = [...tempChatMessages[key], ...sortChatMessage]

                            }
                        }
                    }
                });

                // const worker = new Worker(new URL('./SortChatRoomWorker.ts', import.meta.url));
                // worker.postMessage({ data: tempChatRooms });
                // worker.onmessage = (event) => {
                //     const { data } = event.data;
                //     setListChatRooms(() => data);
                //     worker.terminate();
                // };

                // Update chat messages in room active
                if (isSyncRoom) {
                    setMode('sync-room');
                    setMessages(() => tempChatMessages[`${phoneNumber}`] ?? [])
                }

                setListChatRooms(() => sortChatRooms(tempChatRooms));
                setListChatMessages(() => tempChatMessages);
                totalChatMessage += dataInit.total

                if (dataInit.newestDate) {
                    setSelectedChatPhone((prev) => prev.map((item) => (
                        item.phone === phone ? { ...item, newDateChat: getLatestDate(item.newDateChat, dataInit.newestDate), oldDateChat: dataInit.oldestDate } : item
                    )));

                    // setSelectedChatPhone((prev) => prev.map((item) => (
                    //     item.phone === phone ? { ...item, newDateChat: item.newDateChat && isFirst ? item.newDateChat : dataInit.newestDate, oldDateChat: dataInit.oldestDate } : item
                    // )));
                }

                if (dataInit.total !== 0 && totalChatMessage <= 100000) {
                    if (isFirst) getInitSync(currentLimit, isNew, dataRoom, dataInit.oldestDate, "", phone, color, isFirst, valTokenChat)
                    else {
                        if (dataRoom) getInitSync(currentLimit, isNew, dataRoom, dataInit.oldestDate, "", phone, color, isFirst, valTokenChat)
                        else getInitSync(currentLimit, isNew, dataRoom, "", dataInit.newestDate, phone, color, isFirst, valTokenChat)
                    }
                } else {
                    setIsSyncRoom(() => false)
                    setSelectedChatPhone((prev) => prev.map((item) => (
                        item.phone === phone ? { ...item, lastSycned: moment().format('YYYY-MM-DD HH:mm:ss').toString() } : item
                    )));
                }
            }
        } catch (error: any) {
            const funct = () => getInitSync(currentLimit, isNew, dataRoom, until, since, phone, color, isFirst, valTokenChat);
            handleCheckSession('getChat', funct)
        }
    };

    const getInitGroupSync = async (currentLimit: number, groupId: string, until: string, since: string, phone: string, color: string, isFirst: boolean, valTokenChat: string) => {
        setIsGroupSyncing(() => true)

        try {
            const response = await getInitGroupSyncData(currentLimit, groupId, until, since, phone, valTokenChat, chatMode(settings.chat_version), token);
            if (response.data.success) {
                const { listChatGroupRooms, listChatGroupMessages, groupID, isGroupSyncRoom, setIsGroupSyncRoom, setListChatGroupParticipants } = useChatStore.getState();
                let tempChatGroupRooms = { ...listChatGroupRooms };
                let tempChatGroupMessages = { ...listChatGroupMessages };
                let dataInit = response.data.data;

                dataInit.groups.forEach((chat: any) => {
                    let key = `${chat.id}|${chat.as}`;

                    let tempChat = {
                        ...chat.chats[0] || null,
                        as: chat.as,
                        action: {
                            isEditing: false
                        }
                    }

                    if (!tempChatGroupRooms[key]) {
                        tempChatGroupRooms[key] = {
                            as: chat.as,
                            groupId: chat.id,
                            groupName: "",
                            groupDesc: "",
                            labels: [],
                            chat: tempChat,
                            color: color,
                            connected: true,
                            selected: false,
                            loading: false,
                            owner: "",
                            participants: []
                        }
                    } else {
                        if (isFirst) {
                            tempChatGroupRooms[key] = {
                                ...tempChatGroupRooms[key],
                                groupId: chat.id,
                                // groupName: "",
                            }
                        } else if (!isFirst && !groupId) {
                            tempChatGroupRooms[key] = {
                                ...tempChatGroupRooms[key],
                                as: chat.as,
                                groupId: chat.id,
                                // groupName: "",
                                chat: tempChat,
                            }

                            if (groupID !== key) {
                                setGroupMessageNotifications((prevNotifications) => {
                                    const updatedNotifications = { ...prevNotifications };

                                    chat.chats.forEach((temp: ChatGroupMessage) => {
                                        if (!temp.fromMe) {
                                            updatedNotifications[key] = [
                                                ...(updatedNotifications[key] ?? []),
                                                {
                                                    idLatestMessage: temp.id,
                                                    latestMessage: temp.message,
                                                },
                                            ];
                                        }
                                    });

                                    return updatedNotifications;
                                });
                            }
                        } else if (!tempChatGroupRooms[key].chat.id) {
                            tempChatGroupRooms[key] = {
                                ...tempChatGroupRooms[key],
                                chat: tempChat,
                            }
                        }
                    }

                    const sortChatMessage = chat.chats.map((temp: ChatGroupMessage) => ({
                        ...temp,
                        phone: chat.roomPhone,
                        as: chat.as,
                        action: {
                            isEditing: false
                        }
                    })).sort((a: ChatGroupMessage, b: ChatGroupMessage) => new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime());

                    if (!tempChatGroupMessages[key]) {
                        tempChatGroupMessages[key] = [...sortChatMessage]
                    } else {
                        if (isFirst) {
                            tempChatGroupMessages[key] = [...sortChatMessage, ...tempChatGroupMessages[key]]
                        } else {
                            if (groupId) tempChatGroupMessages[key] = [...sortChatMessage, ...tempChatGroupMessages[key]]
                            else tempChatGroupMessages[key] = [...tempChatGroupMessages[key], ...sortChatMessage]

                        }
                    }
                });

                const tempChatGroupParticipants = Object.values(tempChatGroupMessages).flat().reduce((acc, item, index) => {
                    const phone = item.waSender.phone;
                    if (!acc[phone]) {
                        acc[phone] = {
                            name: item.waSender.name || phone,
                            phone,
                            color: stringToColor(item.waSender.name || item.waSender.phone),
                            lid: ''
                        };
                    } else {
                        acc[phone].name = item.waSender.name || phone;
                    }

                    return acc;
                }, {} as Record<string, ChatGroupParticipant>);

                setListChatGroupRooms(() => sortChatRooms(tempChatGroupRooms));
                setListChatGroupMessages(() => tempChatGroupMessages);
                setListChatGroupParticipants(() => tempChatGroupParticipants);
                totalChatGroupMessage += dataInit.total

                if (dataInit.newestDate) {
                    setSelectedChatPhone((prev) => prev.map((item) => (
                        item.phone === phone ? { ...item, newDateChatGroup: item.newDateChatGroup && isFirst ? item.newDateChatGroup : dataInit.newestDate, oldDateChatGroup: dataInit.oldestDate } : item
                    )));
                }

                if (dataInit.total != 0 && totalChatGroupMessage <= 100000) {
                    if (isFirst) getInitGroupSync(currentLimit, groupId, dataInit.oldestDate, "", phone, color, isFirst, valTokenChat)
                    else {
                        if (groupId) getInitGroupSync(currentLimit, groupId, dataInit.oldestDate, "", phone, color, isFirst, valTokenChat)
                        else getInitGroupSync(currentLimit, groupId, "", dataInit.newestDate, phone, color, isFirst, valTokenChat)
                    }
                } else {
                    setIsGroupSyncRoom(() => false)
                    setSelectedChatPhone((prev) => prev.map((item) => (
                        item.phone === phone ? { ...item, lastGroupSycned: moment().format('YYYY-MM-DD HH:mm:ss').toString() } : item
                    )));
                }
            }
        } catch (error: any) {
            const funct = () => getInitGroupSync(currentLimit, groupId, until, since, phone, color, isFirst, valTokenChat);
            handleCheckSession('getChatGroup', funct)
        }
    };

    const handleIntSync = async (isFirst: boolean, isNew: boolean, type?: 'chat' | 'chat-group', dataRoom?: ChatMessage | ChatGroupMessage) => {
        const { selectedChatPhone, tokenChat, groupID } = useChatStore.getState();

        selectedChatPhone.map((data) =>
            mutate(`${API_URL}chat-group/condiments?mode=${chatMode(settings.chat_version)}&as=${data.phone}`)
        )

        if (selectedChatPhone.length > 0 && tokenChat) {
            let limitInit = 5000
            for (const data of selectedChatPhone) {
                if (isFirst) {
                    await Promise.all([
                        getInitSync(limitInit, isNew, null, "", "", data.phone, data.color, isFirst, tokenChat),
                        getInitGroupSync(limitInit, "", "", "", data.phone, data.color, isFirst, tokenChat),
                    ])
                } else {
                    if (dataRoom && type === 'chat') {
                        await getInitSync(limitInit, isNew, dataRoom as ChatMessage, dataRoom.receivedAt, "", data.phone, data.color, isFirst, tokenChat);
                    } else if (dataRoom && type === 'chat-group') {
                        await getInitGroupSync(limitInit, groupID.split('|')[0], dataRoom.receivedAt, "", data.phone, data.color, isFirst, tokenChat);
                    } else {
                        await getInitSync(limitInit, isNew, null, "", data.newDateChat ? data.newDateChat : "", data.phone, data.color, isFirst, tokenChat);
                        await getInitGroupSync(limitInit, "", "", data.newDateChatGroup ? data.newDateChatGroup : "", data.phone, data.color, isFirst, tokenChat);
                    }
                }

                // Jeda 500ms antar permintaan
                await delay(500);
            }
        }
    }

    const getSetting = async () => {
        try {
            const response = await getSettingAll(token)
            if (response.data.success) {
                setSettings({
                    merchant_title: response.data.data.merchant_title ? response.data.data.merchant_title : "Klien",
                    merchant_custom_fields: response.data.data.merchant_custom_fields ? response.data.data.merchant_custom_fields : "",
                    pipeline_title: response.data.data.pipeline_title ? response.data.data.pipeline_title : "Pipeline",
                    pipeline_custom_fields: response.data.data.pipeline_custom_fields ? response.data.data.pipeline_custom_fields : "",
                    meeting_title: response.data.data.meeting_title ? response.data.data.meeting_title : "Meeting",
                    reimbursement_title: response.data.data.reimbursement_title ? response.data.data.reimbursement_title : "Reimbursement",
                    meeting_custom_fields: response.data.data.meeting_custom_fields ? response.data.data.meeting_custom_fields : "",
                    users_title: response.data.data.users_title ? response.data.data.users_title : 'Users',
                    users_custom_fields: response.data.data.users_custom_fields ? response.data.data.users_custom_fields : '',
                    termins_custom_fields: response.data.data.termins_custom_fields ? response.data.data.termins_custom_fields : '',
                    caps_lock_inputs: response.data.data.caps_lock_inputs === "true" ? true : false,
                    merchant_duplicate: response.data.data.merchant_duplicate === "true" ? true : false,
                    merchant_phone_can_be_changed: response.data.data.merchant_phone_can_be_changed === "true" ? true : false,
                    hide_top_three_sales: response.data.data.hide_top_three_sales === "true" ? true : false,
                    feature_check_number: response.data.data.feature_check_number === "true" ? true : false,
                    feature_pipeline: response.data.data.feature_pipeline === "true" ? true : false,
                    feature_meeting: response.data.data.feature_meeting === "true" ? true : false,
                    feature_chat: response.data.data.feature_chat === "true" ? true : false,
                    feature_chat_super_admin: response.data.data.feature_chat_super_admin === "true" ? true : false,
                    pipeline_abandoned_lock: response.data.data.pipeline_abandoned_lock === "true" ? true : false,
                    pipeline_date_min: response.data.data.pipeline_date_min ? response.data.data.pipeline_date_min : "",
                    template_pipeline: response.data.data.template_pipeline ? response.data.data.template_pipeline : "",
                    feature_meeting_mode: response.data.data.feature_meeting_mode ? response.data.data.feature_meeting_mode : "0",
                    meeting_auto_cancel: response.data.data.meeting_auto_cancel ? Number(response.data.data.meeting_auto_cancel) : -1,
                    feature_reimbursement: response.data.data.feature_reimbursement === "false" ? false : true,
                    update_log_hpp_progress: response.data.data.update_log_hpp_progress === "true" ? true : false,
                    chat_show_pic_only: response.data.data.chat_show_pic_only === "true" ? true : false,
                    chat_superadmin_merchant_only: response.data.data.chat_superadmin_merchant_only === "true" ? true : false,
                    radius_visit: response.data.data.radius_visit ? Number(response.data.data.radius_visit) : 1,
                    update_meeting: response.data.data.update_meeting === "true" ? true : false,
                    unlimited_add_lead_log: response.data.data.unlimited_add_lead_log === "true" ? true : false,
                    feature_activities: response.data.data.feature_activities ? response.data.data.feature_activities === 'true' ? true : false : true,
                    feature_attendance: response.data.data.feature_attendance ? response.data.data.feature_attendance === 'true' ? true : false : false,
                    feature_conference: response.data.data.feature_conference ? response.data.data.feature_conference === 'true' ? true : false : true,
                    feature_email: response.data.data.feature_email ? response.data.data.feature_email === 'true' ? true : false : true,
                    feature_label: response.data.data.feature_label ? response.data.data.feature_label === 'true' ? true : false : true,
                    feature_merchant: response.data.data.feature_merchant ? response.data.data.feature_merchant === 'true' ? true : false : true,
                    feature_product: response.data.data.feature_product ? response.data.data.feature_product === 'true' ? true : false : true,
                    feature_progress: response.data.data.feature_progress ? response.data.data.feature_progress === 'true' ? true : false : true,
                    feature_source: response.data.data.feature_source ? response.data.data.feature_source === 'true' ? true : false : true,
                    feature_target: response.data.data.feature_target ? response.data.data.feature_target === 'true' ? true : false : true,
                    feature_unit: response.data.data.feature_unit ? response.data.data.feature_unit === 'true' ? true : false : true,
                    feature_import_excel_pipeline: response.data.data.feature_import_excel_pipeline ? response.data.data.feature_import_excel_pipeline === 'true' ? true : false : false,
                    meeting_visit_disable_capture_camera: response.data.data.meeting_visit_disable_capture_camera ? response.data.data.meeting_visit_disable_capture_camera === 'true' ? true : false : false,
                    meeting_done_disable_capture_camera: response.data.data.meeting_done_disable_capture_camera ? response.data.data.meeting_done_disable_capture_camera === 'true' ? true : false : false,
                    feature_invoice: response.data.data.feature_invoice ? response.data.data.feature_invoice === 'true' ? true : false : false,
                    company_vat_percentage: response.data.data.company_vat_percentage ? Number(response.data.data.company_vat_percentage) : 0,
                    default_pipeline_view_mode: response.data.data.default_pipeline_view_mode ? response.data.data.default_pipeline_view_mode : "table",
                    is_superadmin_allowed_as_pic: response.data.data.is_superadmin_allowed_as_pic ? response.data.data.is_superadmin_allowed_as_pic === 'true' ? true : false : false,
                    chat_version: response.data.data.chat_version ? response.data.data.chat_version : "v1",
                    sessionsTimeoutInSeconds: response.data.data.sessionsTimeoutInSeconds ? response.data.data.sessionsTimeoutInSeconds : "0",
                    allowAgentPreemptiveStartSessions: response.data.data.allowAgentPreemptiveStartSessions ? response.data.data.allowAgentPreemptiveStartSessions === "true" ? true : false : false,
                    captionWhenSessionEnded: response.data.data.captionWhenSessionEnded ? response.data.data.captionWhenSessionEnded : "",
                    can_init_chat: response.data.data.can_init_chat ? response.data.data.can_init_chat === 'true' ? true : false : false,
                    feature_master: response.data.data.feature_master ? response.data.data.feature_master === 'true' ? true : false : true,
                    is_pipeline_discount_hidden: response.data.data.is_pipeline_discount_hidden ? response.data.data.is_pipeline_discount_hidden === 'true' ? true : false : false,
                    is_pipeline_label_required: response.data.data.is_pipeline_label_required ? response.data.data.is_pipeline_label_required === 'true' ? true : false : false,
                    lead_optional_product: response.data.data.lead_optional_product ? response.data.data.lead_optional_product === 'true' ? true : false : false,
                    chat_show_lead_pic: response.data.data.chat_show_lead_pic ? response.data.data.chat_show_lead_pic === 'true' ? true : false : false,
                    chat_show_merchant_pic: response.data.data.chat_show_merchant_pic ? response.data.data.chat_show_merchant_pic === 'true' ? true : false : false,
                })
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
            })
        }
    }

    const isShowMenuWindow = () => {
        if (phoneNumber || groupID) return true
        else if (windowActive === 'analytic-daily-chat-summary') return true
        else return false
    }

    useEffect(() => {
        getSetting()
        const socket = io(settings.chat_version === 'v2' ? `${API_URL}chat-agent` : `${API_URL}whatsapp-chat`, {
            reconnection: true,
            reconnectionDelayMax: 10000,
            auth: { CRMToken: token, token: tokenChat }
        });
        setSocket(() => socket)
    }, [])

    useEffect(() => {
        const updateNetworkStatus = () => {
            if (!navigator.onLine) {
                socket.disconnect()
                setIsWaitingForNetwork(true);
                setLastSynced(moment().format('YYYY-MM-DD HH:mm:ss').toString())
            } else {
                setIsWaitingForNetwork(false); // Reset waiting state once emitted
            }
        };

        // Event listeners for online/offline status
        window.addEventListener('load', updateNetworkStatus);
        window.addEventListener('online', updateNetworkStatus);
        window.addEventListener('offline', updateNetworkStatus);

        // Clean up the event listeners and interval when component unmounts
        return () => {
            window.removeEventListener('load', updateNetworkStatus);
            window.removeEventListener('online', updateNetworkStatus);
            window.removeEventListener('offline', updateNetworkStatus);
        };
    }, [lastSynced]);

    useEffect(() => {
        if (!versionLoading) {
            const checkVersion = async () => {
                const storedVersion = localStorage.getItem('version-crm');

                if (!storedVersion) {
                    localStorage.setItem('version-crm', version);
                } else if (version !== storedVersion) {
                    localStorage.setItem('version-crm', version);
                    await clearDB(); // Tunggu hingga clearDB selesai
                    window.location.reload(); // Baru reload
                }
            };

            checkVersion();
        }
    }, [version]);

    useEffect(() => {
        if (!leadTemplateLoading) {
            const result = leadTemplate.map((lead: SettingMultiPipelines) => ({
                ...lead,
                label: lead.name,
                value: lead.id,
            }));

            let dataLocal = localStorage.getItem("selectMultiPipeline")
            if (dataLocal) setSelectMultiPipeline(JSON.parse(dataLocal))
            else setSelectMultiPipeline(result[0])
            setMultiPipelines(result);
        }
    }, [leadTemplate]);

    useEffect(() => {
        if (!meetingTemplateLoading) {
            const result = meetingTemplate.map((lead: SettingMultiMeetings) => ({
                ...lead,
                label: lead.name,
                value: lead.id,
            }));

            let dataLocal = localStorage.getItem("selectMultiMeeting")
            if (dataLocal) setSelectMultiMeeting(JSON.parse(dataLocal))
            else setSelectMultiMeeting(result[0])
            setMultiMeetings(result);
        }
    }, [meetingTemplate]);

    useEffect(() => {
        if (!leadsLoading) {
            setSimplePipelines(leads)
        }
    }, [leads]);

    useEffect(() => {
        if (!simpleMeetingsLoading) {
            setSimpleMeetings(simpleMeetingsData)
        }
    }, [simpleMeetingsData]);

    useEffect(() => {
        if (!simpleProductsLoading) {
            setSimpleProducts(simpleProductsData)
        }
    }, [simpleProductsData]);

    useEffect(() => {
        if (!usersLoading) {
            setUsers(userData)
        }
    }, [userData]);

    useEffect(() => {
        if (!labelsIsLoading) {
            setChatLabels(labels)
        }
    }, [labelsIsLoading])

    useEffect(() => {
        if (!quickRepliesIsLoading && quickRepliesData) {
            setQuickReplies(quickRepliesData)
        }
    }, [quickRepliesIsLoading])

    useEffect(() => {
        const { tokenChat } = useChatStore.getState();
        if (!contactsLoading && tokenChat && !contactsError) {
            let dataIncludeName: ContactChatProps[] = []
            let dataExcludeName: ContactChatProps[] = []

            contacts.filter((contact: any) => contact.id.includes('@s.whatsapp.net')).map((contact: any) => {
                if (contact.name || contact.notify || contact.verifiedName) {
                    dataIncludeName.push({
                        ...contact,
                        name: contact.notify || contact.name || contact.verifiedName,
                    })
                } else {
                    dataExcludeName.push({
                        ...contact,
                        name: contact.id.replace('@s.whatsapp.net', '')
                    })
                }
            })

            dataIncludeName.sort((a: any, b: any) => (a.name || "").localeCompare(b.name || ""));
            setChatContacts([...dataIncludeName, ...dataExcludeName]);
        }
    }, [contacts])

    const handleDisconnect = async () => {
        if (socket.active) {
            setTimeout(() => {
                socket.connect();
                const { lastSynced } = useChatStore.getState();
                if (lastSynced) handleIntSync(false, true);
            }, 100);
        } else {
            await clearDB();
            if (connected) {
                Swal.fire({
                    title: intl.formatMessage({ id: "FORM.VALIDATION.DONT_HAVE_ACCESS" }),
                    icon: 'warning',
                    allowOutsideClick: false,
                }).then(async () => {
                    await clearDB();
                    window.location.reload();
                });
            }
        }
    };

    const handleCloseForwardModal = () => {
        setIsOpenForwardChat(false)
        setSelectedChatsForward([])
        setSelectedChatGroupsForward([])
        setForwardChatPayload({
            ...forwardChatPayload,
            targets: [],
        })
        setForwardChatGroupPayload({
            ...forwardChatGroupPayload,
            targets: []
        })
    }

    useEffect(() => {
        const sessionHandler = () => handleCheckSession('sessionDisconnected');

        socket.on('disconnect', handleDisconnect);
        socket.on('sessionDisconnected', sessionHandler);

        return () => {
            socket.off('disconnect', handleDisconnect);
            socket.off('sessionDisconnected', sessionHandler);
        };
    }, [socket]);

    useEffect(() => {
        if (lastSynced) handleIntSync(false, true)
        else handleIntSync(true, false)
    }, [tokenChat])

    useEffect(() => {
        if (!isLoadingAgents && agents?.length) {
            const groupMap = new Map<string, ChatAgent[]>();

            for (const item of agents) {
                const key = `${item.phone}-${item.agent.phone}`;
                const list = groupMap.get(key) || [];

                list.push(item);
                groupMap.set(key, list);
            }

            const sortedResult: Record<string, ChatAgent[]> = {};
            for (const [key, list] of groupMap) {
                sortedResult[key] = list.length <= 1 ? list : list.sort((a, b) => new Date(a.started.date).getTime() - new Date(b.started.date).getTime());
            }

            setListChatAgents(() => sortedResult);
        }
    }, [agents]);

    useEffect(() => {
        const hasLastSynced = selectedChatPhone.length > 0 && selectedChatPhone.every(item => item.lastSycned && item.lastSycned !== null);
        const hasLastGroupSynced = selectedChatPhone.length > 0 && selectedChatPhone.every(item => item.lastGroupSycned && item.lastGroupSycned !== null);
        if (hasLastSynced) setIsSyncing(() => false)
        if (hasLastGroupSynced) setIsGroupSyncing(() => false)
        if (hasLastSynced && hasLastGroupSynced) setLastSynced(moment().format('YYYY-MM-DD HH:mm:ss').toString());
    }, [selectedChatPhone])

    let menu = <></>
    if (menuActive === "settings") menu = <ChatSetting />
    else if (menuActive === "settings-label") menu = <ChatLabelSetting />
    else if (menuActive === "settings-detail-label") menu = <ChatDetailLabelSetting />
    else if (menuActive === "settings-quick-reply") menu = <ChatQuickReplySetting />
    else if (menuActive === "initiate-chat") menu = <ChatInititate />
    else if (menuActive === "analytics") menu = <ChatAnalytics />

    let menuWindow = <></>
    if (windowActive === "analytic-daily-chat-summary") menuWindow = <DailyChatSummary />
    else menuWindow = <ChatWindow handleIntSync={handleIntSync} />

    useDynamicTab({ title: `Wooblazz Chat`, icon: toAbsoluteUrl('/media/logos/logo-wooblazz-chat-square.png') });

    useEffect(() => {
        const handleContextMenu = (e: MouseEvent) => {
            if (location.pathname === '/chat') {
                e.preventDefault();
            }
        };

        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, [location.pathname]);

    useEffect(() => {
        const channel = new BroadcastChannel('whatsapp_tab_channel');
        channel.postMessage('tab_opened');
        channel.onmessage = (event) => {
            if (event.data === 'tab_opened') {
                setIsTabActive(false);
                Swal.fire({
                    title: intl.formatMessage({ id: "ALERT.TITLE.WOOBLAZZ_CHAT_OPEN" }),
                    text: intl.formatMessage({ id: "ALERT.TEXT.WOOBLAZZ_CHAT_OPEN" }),
                    showCancelButton: true,
                    confirmButtonText: intl.formatMessage({ id: "FORM.ACTION.USE_HERE" }),
                    cancelButtonText: intl.formatMessage({ id: "FORM.ACTION.CLOSE" }),
                    confirmButtonColor: '#00a884',
                    cancelButtonColor: '#8696a0',
                }).then((result) => {
                    if (result.isConfirmed) {
                        channel.postMessage('take_control');
                        setIsTabActive(true);
                        window.location.reload();
                    } else {
                        window.close();
                    }
                });
            } else if (event.data === 'take_control') {
                setIsTabActive(false);
                window.close();
            }
        };

        return () => {
            channel.close();
        };
    }, []);

    return (
        <>
            {isTabActive ? (
                <>
                    {
                        !agreedTNC && <ToC />
                    }
                    {
                        !settings.feature_chat ?
                            <PageNoPermisson title='' />
                            :
                            agreedTNC &&
                            <>
                                {
                                    (!tokenChat || !connected) && <SelectUser />
                                }
                                <div className={`row me-0 mt-2 ${(!connected) && 'd-none'}`}>
                                    <div className={`col-12 col-xl-4 d-${isShowMenuWindow() ? 'none' : 'flex'} d-lg-${isShowMenuWindow() ? 'none' : 'flex'} d-xl-flex`}>
                                        <ChatAside />
                                        <ChatSidebar style={(menuActive === "chat" || menuActive === "chat-group") ? { display: "flex" } : { display: "none" }} handleIntSync={handleIntSync} />
                                        {menu}
                                    </div>
                                    <div className={`col-12 col-xl-8 d-${isShowMenuWindow() ? 'block' : 'none'} d-lg-${isShowMenuWindow() ? 'block' : 'none'} d-xl-block`}>
                                        {menuWindow}
                                    </div>
                                </div>
                                <ModalForwardChat isOpen={isOpenForwardChat} onClose={() => handleCloseForwardModal()} />
                            </>
                    }
                </>
            ) : null}
        </>
    )
}

export { Chat } 